// src/pages/payments/PaymentRejected.jsx
// FASE 3.A — PG-05 Pago rechazado (pixel-perfect del mockup v4).
// Source: entregable_claude/screens_states.jsx líneas 80-128.
// Conversión: prop go → useNavigate(); primary "Intentar de nuevo" → /paywall,
// secondary "Volver al inicio" → /.
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useLogoutFlow } from '../../auth/useLogoutFlow';
import { useSmartBack } from '../../auth/useSmartBack';
import SplashScreen from '../../components/SplashScreen';

export default function PaymentRejected() {
  const navigate = useNavigate();
  const goBack = useSmartBack();
  const { showLogoutSplash, startLogout, handleLogoutComplete } = useLogoutFlow();

  // FIX bug crítico (paywall-trapped-user): escape del estado rechazado.
  // FASE UX: useLogoutFlow encapsula el flow completo con splash.
  const handleSignOut = startLogout;

  // FIX BUG 2: early return cuando hay logout splash activo.
  if (showLogoutSplash) {
    return <SplashScreen type="logout" onComplete={handleLogoutComplete} />;
  }

  return (
    <div className="mobile-root">
      <Helmet>
        <title>Pago rechazado · Edge Elite</title>
      </Helmet>

      <section
        className="screen"
        style={{
          paddingTop: 60,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          paddingBottom: 120,
        }}
      >
        <div
          style={{
            width: 96,
            height: 96,
            borderRadius: 999,
            background: 'rgba(220,38,38,.12)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: 28,
          }}
        >
          <svg
            width="48"
            height="48"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#DC2626"
            strokeWidth="2.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
            <path d="M15 9l-6 6" />
            <path d="M9 9l6 6" />
          </svg>
        </div>

        <div
          style={{
            fontSize: 11,
            fontWeight: 700,
            textTransform: 'uppercase',
            letterSpacing: '.1em',
            color: '#DC2626',
            marginBottom: 10,
          }}
        >
          Pago rechazado
        </div>
        <h2
          style={{
            fontFamily: 'var(--font-display)',
            fontSize: 26,
            fontWeight: 700,
            letterSpacing: '-0.025em',
            margin: 0,
            marginBottom: 10,
            lineHeight: 1.2,
          }}
        >
          Tu pago no se pudo procesar
        </h2>
        <p style={{ fontSize: 14, color: 'var(--muted)', margin: 0, marginBottom: 28, maxWidth: 320, lineHeight: 1.5 }}>
          El banco rechazó la transacción.{' '}
          <strong style={{ color: 'var(--ink)', fontWeight: 600 }}>No se realizó ningún cargo</strong>. Verifica tus
          datos o usa otra tarjeta.
        </p>

        <div
          style={{
            width: '100%',
            maxWidth: 360,
            background: 'var(--bg-elev)',
            border: '1px solid var(--line)',
            borderRadius: 14,
            padding: 16,
            textAlign: 'left',
            marginBottom: 24,
          }}
        >
          <div className="eyebrow" style={{ marginBottom: 10 }}>
            Detalles
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              padding: '8px 0',
              borderBottom: '1px solid var(--line)',
            }}
          >
            <span style={{ fontSize: 13, color: 'var(--muted)' }}>Plan</span>
            <span style={{ fontSize: 13, fontWeight: 600 }}>Trimestral · 3 meses</span>
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              padding: '8px 0',
              borderBottom: '1px solid var(--line)',
            }}
          >
            <span style={{ fontSize: 13, color: 'var(--muted)' }}>Monto intentado</span>
            <span style={{ fontSize: 13, fontWeight: 600 }} className="num">
              $38.970
            </span>
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              padding: '8px 0',
              borderBottom: '1px solid var(--line)',
            }}
          >
            <span style={{ fontSize: 13, color: 'var(--muted)' }}>Tarjeta</span>
            <span style={{ fontSize: 13, fontWeight: 600 }}>Visa ···· 4821</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0' }}>
            <span style={{ fontSize: 13, color: 'var(--muted)' }}>Código de error</span>
            <span className="num" style={{ fontSize: 12, fontWeight: 600, color: '#DC2626' }}>
              ERR_CARD_DECLINED · 4001
            </span>
          </div>
        </div>

        <div
          style={{
            width: '100%',
            maxWidth: 360,
            padding: 14,
            background: 'var(--bg-subtle)',
            borderRadius: 10,
            fontSize: 12,
            color: 'var(--muted)',
            lineHeight: 1.55,
            textAlign: 'left',
          }}
        >
          <strong style={{ color: 'var(--ink)', fontWeight: 600 }}>Razones frecuentes:</strong> fondos insuficientes,
          tarjeta sin compras internacionales habilitadas, datos incorrectos, o tu banco bloqueó la transacción por
          seguridad.
        </div>
      </section>

      <div className="sticky-cta" style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        <button className="btn-primary accent" onClick={() => navigate('/paywall')}>
          Intentar de nuevo
        </button>
        <button
          onClick={goBack}
          style={{
            width: '100%',
            padding: '12px 20px',
            background: 'transparent',
            border: 0,
            color: 'var(--muted)',
            fontSize: 14,
            fontWeight: 500,
            cursor: 'pointer',
          }}
        >
          Volver al inicio
        </button>
        {/* FIX bug crítico: link descubrible para cerrar sesión */}
        <div style={{ textAlign: 'center', fontSize: 12, color: 'var(--muted)', marginTop: 4 }}>
          ¿No es tu cuenta?{' '}
          <button
            type="button"
            onClick={handleSignOut}
            style={{
              background: 'none',
              border: 0,
              padding: 0,
              color: 'var(--accent)',
              fontSize: 12,
              fontWeight: 600,
              cursor: 'pointer',
              textDecoration: 'underline',
              fontFamily: 'inherit',
            }}
          >
            Cerrar sesión
          </button>
        </div>
      </div>
    </div>
  );
}
